<template>
  <v-modal name="markdown-document" class="modal" :width="750" height="auto" scrollable close-button
    @before-open="content = $event.params">
    <v-markdown :content="content" />
  </v-modal>
</template>

<script>
import VModal from './VModal.vue';
import VMarkdown from './VMarkdown.vue';

export default {
  components: {
    VModal,
    VMarkdown,
  },
  data() {
    return {
      content: '',
    };
  },
};
</script>
